import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { format, intlFormat, parseISO } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { orderStatus } from 'helpers/orders';
import { convertUTCDateToLocalDate } from 'helpers/date';


const defaultCustomerGroups = [
  {
    id: 0,
    code: 'Not Logged In'
  }
];

const OrderAccountInfo = ({ order }) => {
  const {
    increment_id,
    created_at,
    status,
    store_name,
    customer_firstname,
    customer_lastname,
    customer_email,
    customer_id,
    customer_group_id,
    customer_dob,
    billing_address: {
      firstname,
      lastname,
    }
  } = order;
  const dobDate = customer_dob?.slice(0, 10);
  const hasDob = Boolean(dobDate) && dobDate !== '1971-01-01';
  const { customerGroups } = useSelector(
    (state: { customers: ICustomersState }) => state.customers
  );
  const customerGroupName = [...customerGroups, ...defaultCustomerGroups]
    .find((group) => group.id == customer_group_id)?.code || '---';

  return (
    <TableContainer>
      <Table className="inheritTable">
        <TableHead>
          <TableRow>
            <TableCell width="10%" />
            <TableCell>Order Information</TableCell>
            <TableCell width="10%" />
            <TableCell>Account Information</TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell width="10%" />
            <TableCell>
              <div className="flex-column pr-10">
                <span className="text-14 font-bold uppercase">Order #{increment_id}</span>
                <div className="flex items-center justify-between flex-wrap mt-5">
                  <span>Order Date</span>
                  <span>
                    {intlFormat(convertUTCDateToLocalDate(created_at),
                      {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true
                      },
                      { locale: 'en-US' }
                    )}
                  </span>
                </div>
                <div className="flex items-center justify-between flex-wrap">
                  <span>Order Status</span>
                  <span>{orderStatus[status]}</span>
                </div>
                <div className="flex items-center justify-between flex-wrap">
                  <span>Purchase From</span>
                  <span>{store_name.split('\n')[0]}</span>
                </div>
              </div>
            </TableCell>
            <TableCell width="10%" />
            <TableCell className="align-top">
              <div className="flex-column pr-10">
                <div className="flex items-center justify-between flex-wrap">
                  <span>Customer Name</span>
                  {Boolean(customer_id) ?
                    <Link
                      to={`/customers/${customer_id}/details`}
                      className="text-primary underline"
                    >
                      {customer_firstname ? customer_firstname : firstname}{' '}
                      {customer_lastname ? customer_lastname : lastname}
                    </Link>
                    :
                    <span>
                      {customer_firstname ? customer_firstname : firstname}{' '}
                      {customer_lastname ? customer_lastname : lastname}
                    </span>
                  }
                </div>
                <div className="flex items-center justify-between flex-wrap">
                  <span>Email</span>
                  <span>{customer_email}</span>
                </div>
                <div className="flex items-center justify-between flex-wrap">
                  <span>Customer Group</span>
                  <span>{customerGroupName}</span>
                </div>
                {hasDob &&
                  <div className="flex items-center justify-between flex-wrap">
                    <span>Date of Birth</span>
                    <span>
                      {format(parseISO(dobDate), 'MM/dd/yyyy')}
                    </span>
                  </div>
                }
              </div>
            </TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderAccountInfo;
